export type ProductCategoryId =
  | 'clothing'
  | 'electronics'
  | 'food'
  | 'services'
  | 'digital-services'
  | 'digital'
  | 'beauty'
  | 'home';

export type HomePageTabId = 'all' | ProductCategoryId;

export interface ProductCategory {
  id: ProductCategoryId;
  name: string;
  subtitle: string;
  tabLabel: string;
}

export const PRODUCT_CATEGORIES: ProductCategory[] = [
  { id: 'clothing', name: 'Clothing', subtitle: 'Traditional & Modern', tabLabel: 'Clothing' },
  { id: 'electronics', name: 'Electronics', subtitle: 'Latest Tech', tabLabel: 'Electronics' },
  { id: 'food', name: 'Food', subtitle: 'Authentic Cuisine', tabLabel: 'Food' },
  { id: 'services', name: 'Door2Door', subtitle: 'Local delivery & services', tabLabel: 'Services' },
  { id: 'digital-services', name: 'Digital Services', subtitle: 'Online & remote services', tabLabel: 'Digital Services' },
  { id: 'digital', name: 'Digital Products', subtitle: 'Downloads, files & access', tabLabel: 'Digital' },
  { id: 'beauty', name: 'Beauty', subtitle: 'Asian Beauty', tabLabel: 'Beauty' },
  { id: 'home', name: 'Home & Living', subtitle: 'Decor & Furniture', tabLabel: 'Home & Living' },
];

export const SEARCH_CATEGORY_OPTIONS: { id: HomePageTabId | 'all'; label: string }[] = [
  { id: 'all', label: 'All' },
  ...PRODUCT_CATEGORIES.map((category) => ({
    id: category.id,
    label: category.name,
  })),
];

export const getCategoryDisplayName = (categoryId: string): string => {
  const category = PRODUCT_CATEGORIES.find((item) => item.id === categoryId);
  if (!category) return 'Other';
  if (category.id === 'services') return 'Services';
  if (category.id === 'digital-services') return 'Digital Services';
  return category.name;
};

export const getCategoryFormLabel = (category: ProductCategory): string =>
  `${category.name} - ${category.subtitle}`;

export type ProductType = 'physical' | 'digital';

export const PRODUCT_TYPES: { id: ProductType; label: string; description: string }[] = [
  { id: 'physical', label: 'Physical product', description: 'Ships to the customer' },
  { id: 'digital', label: 'Digital product', description: 'Download or access — no shipping required' },
];
